import { FC } from 'react'
import {
  FinanceWidgetEvents,
  IDimensions,
  MinimalLoader,
  Translation,
  customEvent,
  financeFormInputStorage,
} from '@dxp-module/common'
import clsx from 'clsx'
import { Box, Link, Typography } from '@mui/material'
import { FormInput } from '@dxp-module/common/dist/types/graphql/__generated__/graphql.autogenerated'
import { FinanceFormType } from '../../../common/graphql/__generated__/graphql.autogenerated'
import financeCardStyles from './financeCard.styles'

type FinanceCardProps = {
  amount?: string
  isCash: boolean
  loading: boolean
  dimensions: IDimensions
}

const FinanceCard: FC<FinanceCardProps> = ({
  amount,
  isCash,
  loading,
  dimensions,
}) => {
  const styles = financeCardStyles()

  const onClickOpenCalculator = () => {
    customEvent.emit(FinanceWidgetEvents.FC_ACTIVE_CARD, true)
  }

  const onClickDelete = () => {
    const financeFormInputCash: FormInput = {
      paymentType: FinanceFormType.Cash,
    }

    if (financeFormInputCash) {
      financeFormInputStorage.save(dimensions, financeFormInputCash)
    }

    customEvent.emit(FinanceWidgetEvents.FC_DATA, {})
  }

  return (
    <Box className={styles.container}>
      <Typography className={styles.title} data-test="finance_card:title">
        <Translation id="trans__fincalc__finance_card__section_title" />
      </Typography>

      {isCash && (
        <Link
          component="button"
          underline="always"
          variant="body2"
          className={styles.baseButton}
          data-test="finance_card:link:create"
          onClick={onClickOpenCalculator}
        >
          <Translation id="trans__fincalc__finance_card__create_finance_link" />
        </Link>
      )}
      {loading && <MinimalLoader />}
      {!isCash && !loading && (
        <>
          <Box className={styles.repaymentContainer}>
            <Typography
              variant="body2"
              data-test="finance_card:repayment:label"
            >
              <Translation id="trans__fincalc__finance_card__repayment_label" />
            </Typography>
            {amount && (
              <Typography
                className={styles.repaymentAmount}
                data-test="finance_card:repayment:amount"
              >
                {amount}
              </Typography>
            )}
          </Box>
          <Link
            component="button"
            underline="always"
            variant="body2"
            className={styles.baseButton}
            data-test="finance_card:link:edit"
            onClick={onClickOpenCalculator}
          >
            <Translation id="trans__fincalc__finance_card__modify_link" />
          </Link>
          <Link
            component="button"
            underline="always"
            variant="body2"
            className={clsx([styles.baseButton, styles.deleteButton])}
            data-test="finance_card:link:delete"
            onClick={onClickDelete}
          >
            <Translation id="trans__fincalc__finance_card__delete_link" />
          </Link>
        </>
      )}
    </Box>
  )
}

export default FinanceCard
